import { useEffect, useState } from 'react';
import { variables } from '../themes/variables';
import { debounce } from '../../helpers/debounce';
/**
 * Can't be used in SSR because document is needed
 */
export function useSliderColumns({ columnAmountDefault, columnAmountMobileL, columnAmountTablet, columnAmountLaptop, }) {
    const [columns, setColumns] = useState(2.5);
    useEffect(() => {
        let isMounted = true;
        // Resizing the horizontal sliders will cause an expensive
        // forced layout reflow. Debouncing resizing improves that
        // a bit.
        const update = debounce(() => {
            // seems to be exclusively required for our Jest tests
            // without the debounce() the problem goes away, too
            if (!isMounted) {
                return;
            }
            // eslint-disable-next-line react-hooks-ssr/react-hooks-global-ssr
            const width = document.documentElement.clientWidth;
            const matchMobileL = width >= variables.screenMobileL;
            const matchTablet = width >= variables.screenTabletL;
            const matchLaptop = width >= variables.screenLaptop;
            setColumns(matchLaptop
                ? columnAmountLaptop
                : matchTablet
                    ? columnAmountTablet
                    : matchMobileL
                        ? columnAmountMobileL
                        : columnAmountDefault);
        }, 100);
        update();
        window.addEventListener('resize', update);
        return () => {
            isMounted = false;
            window.removeEventListener('resize', update);
        };
    }, [
        columnAmountDefault,
        columnAmountLaptop,
        columnAmountMobileL,
        columnAmountTablet,
    ]);
    return columns;
}
